import { updateState, withDevtools } from '@angular-architects/ngrx-toolkit';
import { signalStore, withMethods, withState } from '@ngrx/signals';

import { SysAdminStoreActions, initialSysAdminState } from './models';

export const SysAdminStore = signalStore(
  { providedIn: 'root' },
  withState(initialSysAdminState),
  withDevtools('sys-admin'),
  withMethods(store => {
    return {
      selectMenu: (selectedMenu: number) =>
        updateState(store, SysAdminStoreActions.SelectMenu, {
          selectedMenu,
        }),
    };
  }),
);
